<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
            <userLeft :active="10" />
            <div class="box5">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">授信建档</div>
                    <div :class="[CheckAccount.unbindingParent ? '' : 'red', 'button', 'color2']" style="float: right;" @click="unbinding()" v-if="CheckAccount.unbindingParent">解绑主账号</div>
                    <div :class="[CheckAccount.bindingParent ? '' : 'red', 'button', 'color1']" style="float: right;" @click="isShow(1)" @refresh="refresh" v-else-if="CheckAccount.applyAccount">绑定主账号</div>
                    <div :class="[CheckAccount.bindingChild ? '' : 'red', 'button', 'color1']" style="float: right;" @click="isShow(3)" @refresh="refresh" v-if="!CheckAccount.applyAccount">绑定子账号</div>
                    <div :class="[CheckAccount.unbindingChild ? '' : 'red', 'button', 'color2']" style="float: right;" @click="isShow(2)" @refresh="refresh" v-if="!CheckAccount.applyAccount">解绑子账号</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <a-table rowKey="storeId" :columns="columns" :data-source="tablelist" :pagination="false" />
                </div>

                <div class="box6" style="margin-top: 60px; overflow: hidden;">授信额度变化记录</div>
                <div style="overflow: hidden; margin-top: 2%;" :key="index" v-for="(item, index) in list">
                    <a-icon type="clock-circle" style="float: left; margin-top: 5px;" />
                    <div class="record_txt">
                        <span style="min-width: 40%">{{ item.userMobile ? `${item.modifyField}(${item.userMobile})` : item.modifyField }}</span>
                        <span v-if="item.amount > 0">+</span>{{ item.amount / 100 }}
                    </div>
                    <div class="record_time">{{ item.createdAt }}</div>
                </div>

                <div v-if="list.length == 0" style="margin-top: 40px; text-align: center;">
                    没有记录~
                </div>
                <div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
                    <a-pagination show-quick-jumper :default-current="1" :total="totalPages * 10" @change="onChange" />
                </div>
            </div>
        </div>
        <foot />
        <binding v-model="show" :type="type" :usCode="unifiedSocialCreditCode" />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import binding from '../public/binding';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot,
        binding
    },
    data() {
        return {
            totalPages: 1, //总页数
            list: [],
            page: 0,
            data: '',
            show: false, //绑定/解绑弹框
            type: 1,
            columns: [
                {
                    dataIndex: 'storeName',
                    title: '店铺名称'
                },
                {
                    dataIndex: 'creditAmount',
                    title: '授信总额度（元）'
                },
                {
                    dataIndex: 'amountUsed',
                    title: '已用额度（元）'
                },
                {
                    dataIndex: 'amount',
                    title: '剩余可用授信额度（元）'
                }
            ],
            tablelist: [],
            CheckAccount: {},
            unifiedSocialCreditCode: ''
        };
    },
    created() {
        this._getCheckAccount();
        this._getCreditChangeRecordFun();
        this._getCreditTableDataFun();
    },
    methods: {
        _getCheckAccount() {
            this.api.get_user_company_me().then(res => {
                this.unifiedSocialCreditCode = res.data.unifiedSocialCreditCode;
                this.api.getCheckAccount({ usCode: this.unifiedSocialCreditCode }).then(res => {
                    this.CheckAccount = res.data;
                    console.log(res);
                });
            });
        },
        onChange(e) {
            this.page = e - 1;
            this._getCreditChangeRecordFun();
        },
        isShow(type) {
            if (type == 3 && !this.CheckAccount.bindingChild) {
                this.$message.warning('当前机构没有未绑定子账号');
            } else if (type == 2 && !this.CheckAccount.unbindingChild) {
                this.$message.warning('当前账号没有子账号');
            } else if (type == 1 && !this.CheckAccount.bindingParent) {
                this.$message.warning('当前机构没有主账号');
            } else {
                this.type = type;
                this.show = true;
            }
        },
        // 获取变更记录
        _getCreditChangeRecordFun() {
            this.api.get_searchPromote(this.page).then(res => {
                if (res.ok) {
                    console.log(res.data.content);
                    this.list = res.data.content;
                    this.totalPages = res.data.totalPages;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 获取 授信余额 表格列表
        _getCreditTableDataFun() {
            this.api.get_credit_list(this.page).then(res => {
                if (res.ok) {
                    let { data = [] } = res;
                    this.tablelist = data.map(item => {
                        return {
                            ...item,
                            amount: (item.amount / 100).toFixed(2),
                            amountUsed: (item.amountUsed / 100).toFixed(2),
                            creditAmount: (item.creditAmount / 100).toFixed(2)
                        };
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //解绑主账号
        unbinding() {
            let { parentId } = JSON.parse(localStorage.getItem('user_info'));
            this.api.unbind({ uuid: parentId }).then(res => {
                if (res.ok) {
                    this.$message.info(res.message);
                    this._getCheckAccount();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        refresh() {
            this._getCheckAccount();
        }
    }
};
</script>

<style scoped>
.red {
    background-color: #bfbfbf !important;
    color: #fff !important;
    border: 0 !important;
}
.record_time {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: right;
}
.record_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-left: 2%;
    width: 75%;
    float: left;
    display: flex;
}
.yue_item {
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid #ede9e9;
    border-radius: 0px 20px 0px 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
}
.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
    position: relative;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}
.button {
    width: 90px;
    height: 32px;
    border: 1px solid #2b9a34;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    /* color: #2b9a34; */
    line-height: 32px;
    text-align: center;
    margin-left: 10px;
}
.color1 {
    color: #ffffff;
    background: #2b9a34;
}
.color2 {
    color: #2b9a34;
}
div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/credit_y.vue